/**
 * @license Siftrock
 * (c) 2014-2018 Siftrock, Inc. http://siftrock.com
 * Unauthorized copying of this file, via any medium is strictly prohibited
 */

import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class ActonService {

  private listCache: any[] = [];
  private fieldCache: any[] = [];

  constructor(private http: HttpClient) { }

  getFields(listId: string): Observable<any> {
    if (this.fieldCache.length > 0) {
      return Observable.of(this.fieldCache);
    }

    return this.http
      .get(
        `/api/v1/acton/fields?list_id=${listId}`
      )
      .map( (response: any) => {
        this.fieldCache = response || [];
        return this.fieldCache;
      });
  }

  getLists(): Observable<any> {
    if (this.listCache.length > 0) {
      return Observable.of(this.listCache);
    }

    return this.http
      .get(
        `/api/v1/acton/lists`
      )
      .map( (response: any) => {
        this.listCache = response || [];
        return this.listCache;
      });
  }

  grantAccess(code): Observable<any> {
    return this.http
      .post(
        `/api/v1/acton/grant`,
        { code: code }
      );
  }

  clearListCache() {
    this.listCache = [];
  }

  clearFieldCache() {
    this.fieldCache = [];
  }

  clearAll() {
    this.listCache = [];
    this.fieldCache = [];
  }
}



// WEBPACK FOOTER //
// ./client/app/services/acton.service.ts